import * as React from "react";
import { Row, Input } from "antd";
import { TPaymentInstructionPresentationModel } from "../../../presenter/payment/model/PaymentInstructionPresentationModel";
import Text from "antd/lib/typography/Text";
import TextArea from "antd/lib/input/TextArea";

const DomesticAbroadInstructionForm = ({
  translate,
  paymentInstruction
}: {
  translate: any;
  paymentInstruction?: TPaymentInstructionPresentationModel;
}) => {
  return (
    <React.Fragment>
      <div className="content-container">
        <div className="content-section content-section-border">
          <Row>
            <Text className={"content-section-title"}>
              {translate("payment_instruction_page.domestic")}
            </Text>
          </Row>
          <Row className={"group-items"}>
            <Text className={"label"}>
              {translate("payment_instruction_page.receiver")}
            </Text>
            <TextArea
              rows={3}
              readOnly
              className={"input"}
              value={paymentInstruction?.domestic?.receiver}
            />
          </Row>
          <Row className={"group-items"}>
            <Text className={"label"}>
              {translate("payment_instruction_page.account_number")}
            </Text>
            <Input
              readOnly
              className={"input"}
              value={paymentInstruction?.domestic?.accountNumber}
            />
          </Row>
        </div>
        <div className="content-section content-section-emphasize">
          <Row>
            <Text className={"content-section-title"}>
              {translate("payment_instruction_page.abroad")}
            </Text>
          </Row>
          <Row className={"group-items"}>
            <Text className={"label"}>
              {translate("payment_instruction_page.receiver")}
            </Text>
            <TextArea
              rows={3}
              readOnly
              className={"input"}
              value={paymentInstruction?.abroad?.receiver}
            />
          </Row>
          <Row className={"group-items"}>
            <Text className={"label"}>
              {translate("payment_instruction_page.swift_code")}
            </Text>
            <Input
              readOnly
              className={"input"}
              value={paymentInstruction?.abroad?.swiftCode}
            />
          </Row>
          <Row className={"group-items"}>
            <Text className={"label"}>
              {translate("payment_instruction_page.bank_name")}
            </Text>
            <Input
              readOnly
              className={"input"}
              value={paymentInstruction?.abroad?.bankName}
            />
          </Row>
          <Row className={"group-items"}>
            <Text className={"label"}>
              {translate("payment_instruction_page.account_number")}
            </Text>
            <Input
              readOnly
              className={"input"}
              value={paymentInstruction?.abroad?.accountNumber}
            />
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DomesticAbroadInstructionForm;
